module.exports = __webpack_public_path__ + "static/media/vacuderma-3.0d9481de.jpg";